// components
import { DefaultOption, GoalOutlookOption } from "./components/Options";

// fetches the correct option component based on the type of the ajax picker
export const getOptionComponent = (type, optionData) => {
	switch (type) {
		case "goalCategories" ||
			"reviewForms" ||
			"templates" ||
			"department" ||
			"reviewFormNames" ||
			"workflowTemplates":
			return DefaultOption(optionData);
		case "goalOutlook":
			return GoalOutlookOption(optionData);
		default:
			return DefaultOption(optionData);
	}
};
